<script>
  import fetchContent from "../../sanity.js";
  import Loading from "../Loading.svelte";

const query ='*[_type == "event"]{ name, date, "logo": logo.asset -> url } | order( name asc )';
  const events = fetchContent(query);
</script>

<section id="artfairs">
  <h1>Art Fairs</h1>
  {#await events}
  <Loading />
  {:then results}
  <ul>
  {#each results as event}
    <li>
    <img src="{event.logo}" alt="">
    <h2 class="eventname">{event.name}</h2>
    <p class="date">{event.date}</p>
    </li>
  {/each}
  </ul>
    {/await}
</section>

<style>
    ul {
        width: min(100%, 70rem);
        margin: 2rem auto;
        line-height: 1;
        
    }
    li {
        padding: 2rem 1rem;
        display: grid;
        grid-gap: 0 10%;
        grid-template: "logo eventname" auto "logo date" auto / 30% 60%;
        align-content: center;
        border-bottom: solid 1px var(--c-secondary);
        text-align: left;
    }
    img {
        grid-area: logo;
        justify-self: right;
        align-self: center;
        width: 100%;
        max-width: 150px;
    }

    h2.eventname{
        align-self: flex-end;
        grid-area: eventname;
        padding: 0.2rem 0;
        margin: 0;
    }

    p.date {
        align-self: flex-start;
        grid-area: date;
        padding: 0.2rem 0;
        line-height: 1;
        margin: 0;
    }
</style>